import React from "react";
import { shallowEqual } from "react-redux";
import type { UscLabelType } from "../../../../../utils/labels";
import { useUscOptionalLabel } from "../../../../../utils/labels";
import { useUscSelector } from "../../../../../redux/store";
import Text from "../../../styles/atoms/Text";
import { DisclaimerLocation } from "../../../../../../../common-deprecated/types/CommonTypes";
import { disclaimerSelector } from "../../../../../utils/disclaimerUtils";
import NumberedDisclaimerIcon from "../../../../../../../common-deprecated/styles/v2/lexus/custom/NumberedDisclaimerIcon";
import * as Styles from "./BasketDisclaimers.styles";
import { getBasketDisclaimerLabel } from "../../../../../utils/helpers";

const BasketDisclaimers = (): JSX.Element | null => {
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const financeOption = useUscSelector((state) => state.basket.activeFinanceOption);
    const disclaimerLabel = useUscOptionalLabel(getBasketDisclaimerLabel(financeOption, vehicleType) as UscLabelType);

    const disclaimers = useUscSelector(disclaimerSelector, shallowEqual);
    const footnoteDisclaimers = disclaimers.filter((disclaimer) => disclaimer.location === DisclaimerLocation.Footnote);

    if (!disclaimerLabel && !footnoteDisclaimers.length) return null;

    return (
        <Text tag="div" variant="paragraph-small-book" color="platinum-dark">
            {disclaimerLabel}

            {footnoteDisclaimers.map((disclaimer) => {
                return (
                    <Styles.FootnoteDisclaimerWrapper key={disclaimer.number}>
                        {/* Parent is flexbox, if we don't wrap the disclaimer icon with a div it's proportions will no longer be correct */}
                        <div>
                            <NumberedDisclaimerIcon>{disclaimer.number}</NumberedDisclaimerIcon>
                        </div>

                        <Text variant="paragraph-small-book">
                            {disclaimer.containsHtml ? (
                                <span dangerouslySetInnerHTML={{ __html: disclaimer.value }} />
                            ) : (
                                <span>{disclaimer.value}</span>
                            )}
                        </Text>
                    </Styles.FootnoteDisclaimerWrapper>
                );
            })}
        </Text>
    );
};

export default BasketDisclaimers;
